import css from 'styled-jsx/css';

export default css`
  .pricing-container {
    padding-top: 60px;
  }
  :global(.pricing-content) {
    margin: auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    position: relative;
    border-radius: 10px;
    background: var(--background-utils);
    border: 1px solid var(--card-border);
  }

  :global(.tabs-container) {
    display: flex;
    flex-direction: row;
    position: absolute;
    top: -75px;
    align-items: flex-end;
    width: 100%;
    justify-content: center;
  }

  .section-wrap {
    width: 100%;
    border-radius: 10px 10px 0px 0px;
    position: absolute;
    bottom: -30px;
    margin: auto;
    height: 30px;
    background: var(--background-utils);
    z-index: 2;
  }

  @media only screen and (max-width: 470px) {
    :global(.plans) {
      display: flex;
      margin-bottom: 0px !important;
      flex-wrap: wrap;
      justify-content: center;
      align-items: flex-start;
      gap: 0px !important;
      margin-top: 40px;
    }
    :global(.tabs-container) {
      top: -75px !important;
    }
    :global(iframe) {
      color-scheme: auto;
      padding-bottom: 0px;
    }
    .hide-chat {
      display: none;
    }
    .show-chat {
      display: block;
    }

    .section-wrap {
      border-radius: 0px;
    }
  }

  :global(.tab) {
    background: var(--background-utils);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 22px;
    height: 75px;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--card-border);
    border-bottom: none;
    box-shadow: 0 4px 12px 0 rgb(122 43 43 / 10%),
      0 7px 25px 0 rgb(80 52 52 / 10%), 0 0 0 1px rgb(146 122 122 / 5%);
    border-radius: 8px 8px 0px 0px;
  }

  :global(.tab-inactive) {
    background-color: var(--switch-background);
    cursor: pointer;
    border-bottom: none;
    box-shadow: none;
    height: 75px;
  }

  :global(:first-child(.tab-inactive)) {
    border-radius: 70px;
  }

  :global(.tab-icon) {
    height: 60px;
    width: 60px;
    margin: 5px 0px;
  }

  :global(.tab-text) {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    cursor: default;
    text-align: center;
    color: var(--primary);
  }

  :global(.tab-text-inactive) {
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    cursor: pointer;
    color: var(--grey-lighter);
  }

  .mt-xxxl {
    margin-bottom: 95px;
  }

  @media only screen and (max-width: 470px) {
    :global(.pricing-head) {
      margin-bottom: 16px;
    }
    .mt-xxxl {
      margin-bottom: 90px;
    }
    .tab-text-inactive {
      font-style: normal;
      font-weight: 500 !important;
      font-size: 12px !important;
      cursor: pointer;
      text-align: center;
      color: var(--grey-lighter);
    }
    .tab-text {
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      line-height: 15px;
      cursor: default;
      text-align: center;
    }
    :global(.tab) {
      padding: 5px;
      flex: 1;
    }
  }

  :global(.plans) {
    display: flex;
    margin-bottom: 40px;
    justify-content: center;
    align-items: flex-start;
    gap: 12px;
    padding: 0px 10px;
    margin-top: 60px;
  }

  @media only screen and (max-width: 668px) {
    :global(.plans) {
      padding: 1em;
      margin-top: 30px;
    }
    :global(.plans > div:first-child) {
      margin-right: 0px !important;
      margin-left: 0px !important;
    }
    :global(.plans > div) {
      margin-right: 0px !important;
      margin-left: 0px !important;
      margin-top: 20px;
    }
  }
  @media only screen and (max-width: 360px) {
    :global(.plans > div:not(:last-child)) {
      margin-right: 0;
    }
  }
  @media only screen and (max-width: 360px) {
    :global(.plans > div:last-child) {
      margin-right: 0;
    }
  }

  :global(.button-group) {
    margin-top: 32px;
    position: relative;
  }

  :global(.button-group-container) {
    background: var(--switch-background) !important;
    padding: 4px !important;
  }

  .plans :global(iframe) {
    color-scheme: auto;
    padding-bottom: 70px;
  }

  :global(.kayako-messenger) {
    bottom: 40px;
  }

  .chat {
    position: fixed;
    bottom: 20px;
    right: 25px;
    z-index: 11000000000;
  }

  .mobile-chat {
    position: fixed;
    top: 10px;
    right: 10px;
    z-index: 11000000000;
  }

  .chat img,
  .mobile-chat img {
    height: 45px;
    cursor: pointer;
  }

  .transparent-chat {
    background: transparent;
    height: 60px;
    width: 60px;
  }

  :global(.title-plans) {
    margin-top: 40px;
    text-align: center;
    padding: 2px 10px;
    max-width: 800px;
  }

  :global(.title-plans h4) {
    color: var(--foreground);
    font-weight: 600;
  }

  :global(.title-plans p) {
    color: var(--grey-lighter);
    margin-top: 10px;
  }

  :global(.switch-plan-position) {
    position: absolute;
    bottom: -32px;
    right: 0px;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    line-height: 16px;
    color: #006855;
    background: #7fffe1;
    padding: 5px;
    border-radius: 5px;
  }

  :global(.switch-plan-arrow) {
    position: absolute;
    right: -20px;
    top: 70px;
  }

  :global(.pricing-card-container) {
    border: 1px solid var(--card-border-pricing);
    border-radius: 10px;
    position: relative;
    max-width: 340px;
    width: 100%;
  }

  :global(.pricing-wrapper-desc) {
    margin: auto;
    padding: 25px 20px 10px;
  }

  :global(.pricing-card-title) {
    font-weight: 500;
    font-size: 22px;
  }

  :global(.pricing-card-title-divider) {
    width: 50px;
    height: 4px;
    margin-top: 6px;
    border-radius: 100px;
  }

  :global(.pricing-card-price-container) {
    padding: 0px 20px 10px;
    position: relative;
  }

  :global(.pricing-card-discount) {
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    text-decoration: line-through;
    color: var(--foreground);
  }
  :global(.pricing-card-saving) {
    font-size: 14px;
  }

  :global(.pricing-card-price) {
    font-style: normal;
    font-weight: 700;
    font-size: 40px;
  }

  :global(.pricing-card-description-user p) {
    font-size: 14px;
    font-weight: 400;
  }

  :global(.pricing-card-description-row) {
    display: flex;
    flex-direction: row;
  }

  :global(.pricing-card-description-text) {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
  }

  :global(.pricing-card-icon) {
    height: 16px;
    width: 16px;
    margin-right: 10px;
  }

  :global(.pricing-card-cta) {
    padding: 10px 20px 10px;
  }

  :global(.pricing-card-cta .button) {
    width: 100%;
    position: relative;
  }

  :global(.pricing-card-button-arrow) {
    position: absolute;
    right: 20px;
  }

  :global(.pricing-card-most-popular) {
    background: var(--bg-most-popular);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 5px 10px;
    box-sizing: border-box;
    border-radius: 2px;
  }

  :global(.pricing-card-news) {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 5px 10px;
    background: #fe8e464f;
    box-sizing: border-box;
    border-radius: 2px;
  }

  :global(.pricing-card-crown-icon) {
    width: 20px;
    height: 16px;
  }

  :global(.pricing-card-news .icon) {
    font-size: 22px;
    color: #fe8348;
    margin-top: 5px;
  }

  :global(.pricing-card-most-popular-text) {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    color: #005eff;
    margin-left: 7px;
  }

  :global(.pricing-card-news-text) {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    color: var(--bsocial-color);
    margin-left: 7px;
  }

  :global(.pricing-card-accordion-content) {
    display: flex;
    flex-direction: column;
    padding: 10px 20px 20px;
  }

  :global(.pricing-card-divider) {
    border-bottom: 0.5px solid var(--card-border-pricing);
  }

  :global(.pricing-card-ribbon) {
    z-index: 1;
    overflow: hidden;
    text-align: right;
  }
  :global(.pricing-card-ribbon span) {
    font-size: 14px;
    letter-spacing: 1px;
    font-weight: 500;
    color: var(--ribbon-span);
    text-align: center;
    line-height: 25px;
    padding-top: 5px;
    width: 100%;
    display: block;
    position: absolute;
    top: 0px;
    left: 0px;
    border-radius: 10px 10px 0px 0px;
  }

  :global(.pricing-card-accordion-content li) {
    padding: 6px;
  }
  :global(.pricing-card-accordion-description li),
  :global(.pricing-card-accordion-description) {
    padding: 0px 0px 10px;
    font-size: 14px;
    font-weight: 300;
  }

  :global(.pricing-card-accordion-content ul) {
    font-size: 14px;
    font-weight: 300;
  }

  .pricing-card-container :global(.accordion-container .accordion-icon) {
    visibility: hidden;
  }

  .pricing-content :global(.accordion-container) {
    margin-top: 0px !important;
    border: none;
  }

  .pricing-card-container :global(.accordion-container) {
    padding: 0px;
    border: none;
  }

  .pricing-card-container :global(.accordion-container span) {
    text-decoration: underline;
    color: var(--underline-cta);
  }

  @media only screen and (max-width: 460px) {
    :global(.pricing-card-title) {
      font-size: 20px;
      margin-top: 5px;
    }
    :global(.pricing-card-price) {
      font-size: 30px;
    }
    :global(.pricing-card-price-container) {
      padding: 0px 16px 10px;
    }
    :global(.pricing-card-description) {
      min-height: 0px;
      padding: 10px 16px !important;
      min-height: 120px;
    }
    :global(.title-plans p) {
      font-size: 14px;
    }
    :global(.section-find-more) {
      padding: 10px !important;
    }
    :global(.pricing-wrapper-desc) {
      padding: 16px 16px 10px !important;
    }
    :global(.pricing-card-cta) {
      padding: 10px 16px 10px !important;
    }
    :global(.switch-plan-arrow) {
      position: absolute;
      right: -20px;
      top: 50px;
    }
    h2 {
      font-size: 30px;
    }
    :global(.pricing-card-most-popular) {
      margin-top: 5px;
    }

    :global(.pricing-card-news) {
      margin-top: 5px;
    }
  }
  :global(.sub-text) {
    font-size: 14px;
    font-style: italic;
    text-align: center;
  }
  .upgrade-description span {
    font-size: 13px;
    font-style: italic;
    font-weight: 400;
  }
  .upgrade-modal h4 {
    color: var(--primary);
  }
  .promo-active-span {
    color: white;
    font-size: 13px;
    background: #c7ac75;
    padding: 1px;
  }
`;
